var tocomanUi = require("@tocoman/ui");
var ProjectList = require("src/client-ts/containers/Projects/ProjectList");

exports.tocoUiButton = tocomanUi.Button;

exports._projectList = ProjectList.ProjectList;
